<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <p class="description">{{ 'pleaseSelectYourLanguage' | translate }}</p>
  <saf-language-select formControlName="language" required></saf-language-select>
  <div fxLayoutAlign="end">
    <button class="administration" type="submit" mat-raised-button color="primary">{{ 'next' | translate }}</button>
  </div>
</form>
